<div class="container m-b-20 layout-row layout-lt-md-column align-end gap-2percent">
  <button mat-raised-button color="primary" [routerLink]="['edit']" *LOSxHasPermission="'UPDATE_DELINQUENCY_BUCKET'">
    <fa-icon icon="edit" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Edit' | translate }}
  </button>
  <button
    mat-raised-button
    color="warn"
    (click)="deleteDelinquencyBucket()"
    *LOSxHasPermission="'DELETE_DELINQUENCY_BUCKET'"
  >
    <fa-icon icon="trash" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Delete' | translate }}
  </button>
</div>

<div class="container">
  <mat-card>
    <mat-card-content>
      <div class="layout-row-wrap">
        <div class="flex-100 layout-row m-b-10">
          <div class="flex-30 mat-body-strong">
            {{ 'labels.inputs.Name' | translate }}
          </div>

          <div class="flex-70">
            {{ delinquencyBucketData.name }}
          </div>
        </div>

        <div class="flex-60 mat-body-strong">
          {{ 'labels.inputs.Classification' | translate }}
          {{ 'labels.inputs.Name' | translate }}
        </div>

        <div class="mat-body-strong flex-20">
          {{ 'labels.inputs.Days From' | translate }}
        </div>

        <div class="mat-body-strong flex-20">
          {{ 'labels.inputs.Days Till' | translate }}
        </div>
      </div>

      @for (range of delinquencyBucketData.ranges; track range) {
        <div class="layout-row-wrap bucket-range">
          <div class="flex-60">
            {{ range.classification }}
          </div>
          <div class="flex-20 r-value">
            {{ range.minimumAgeDays }}
          </div>
          <div class="flex-20 r-value">
            {{ range.maximumAgeDays }}
          </div>
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>
